<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="600px"
    append-to-body=""
    :close-on-press-escape="false"
    @closed="handleClose">
    <el-form
      ref="ruleForm"
      :model="certificate"
      label-position="left"
      :rules="rules"
      label-width="85px">
      <el-form-item
        v-if="vendorId"
        label="证书名称:"
        prop="certName">
        <el-input
          v-model.number="certificate.certName"
          style="width: 300px"></el-input>
      </el-form-item>
      <el-form-item
        v-else
        label="证书名称:">
        <span> {{ certName }}</span>
      </el-form-item>
      <el-form-item
        label="有效期:"
        prop="time">
        <el-date-picker
          v-model="certificate.time"
          style="width: 300px"
          type="daterange"
          unlink-panels
          range-separator=""
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item
        label="证书文件:"
        prop="certFile">
        <custom-upload-file
          v-model="certificate.certFile"
          :limit="5"
          rolate
          accept="image/*,.pdf"
          @update:loading="handleLoading" />
      </el-form-item>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import CustomUploadFile from '@/components/public/custom-upload-file.vue'
// import UploadImage from '@/components/public/upload-image-new.vue'
export default {
  name: 'CertificateModal',
  components: { CustomUploadFile },
  props: {
    fetch: {
      type: Function,
      required: true
    },
    vendorId: [String, Number],
    certId: [String, Number],
    certName: String,
    current: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      certificate: {
        certName: '',
        time: '',
        certFile: []
      },
      rules: {
        certName: [{ required: true, message: '请输入证书名称', trigger: 'blur' }],
        time: [
          { required: true, message: '请选择有效期', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (Array.isArray(value) && value[1].getTime() < Date.now()) {
                callback(new Error('有效期的结束时间必须大于今天'))
              }
              callback()
            },
            trigger: 'blur'
          }
        ],
        certFile: [{ required: true, message: '请上传证书文件', trigger: 'change' }]
      }
    }
  },
  computed: {
    title() {
      return this.vendorId ? '新建证书' : this.certificate.certFileId ? '修改证书文件' : '新建证书文件'
    }
  },
  watch: {
    current: {
      handler(val) {
        if (val.certFileId) {
          this.certificate = {
            ...this.certificate,
            ...val
          }
        }
      },
      deep: true
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClose() {
      this.$refs.ruleForm.resetFields()
      this.certificate = {
        certName: '',
        time: '',
        certFile: []
      }
    },
    handleLoading(loading) {
      this.loading = loading
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          if (this.vendorId) {
            this.addcertificate()
          } else if (this.certificate.certFileId) {
            this.updatecertificatefile()
          } else {
            this.addcertificatefile()
          }
        }
      })
    },
    addcertificate() {
      this.$store.dispatch('certificate/addcertificate', {
        payload: {
          vendorId: this.vendorId,
          certLevel: 1,
          ...this.certificate,
          certBeginTime: +this.certificate.time[0],
          certEndTime: +this.certificate.time[1],
          certFile: this.certificate.certFile.map(item => item.url).join(',')
        },
        success: () => {
          this.loading = false
          this.toggleModal(false)
          this.fetch && this.fetch()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    updatecertificatefile() {
      this.$store.dispatch('certificate/updatecertificatefile', {
        payload: {
          certId: this.certId,
          certFileId: this.certificate.certFileId,
          certBeginTime: +this.certificate.time[0],
          certEndTime: +this.certificate.time[1],
          certFile: this.certificate.certFile.map(item => item.url).join(',')
        },
        success: () => {
          this.loading = false
          this.toggleModal(false)
          this.fetch && this.fetch()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    addcertificatefile() {
      this.$store.dispatch('certificate/addcertificatefile', {
        payload: {
          certId: this.certId,
          certBeginTime: +this.certificate.time[0],
          certEndTime: +this.certificate.time[1],
          certFile: this.certificate.certFile.map(item => item.url).join(',')
        },
        success: () => {
          this.loading = false
          this.toggleModal(false)
          this.fetch && this.fetch()
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
